var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { BackrsUserBadge } from '@backrs_ui/common-ui/src/atoms/BackrsUserBadge';
import { Box } from '@mui/material';
import { NuggetProfilePanel } from './NuggetProfilePanel';
var ProfileWidget = function (_a) {
    var abbreviatedName = _a.abbreviatedName, location = _a.location, jobTitle = _a.jobTitle, employer = _a.employer, school = _a.school, profileImageUrl = _a.profileImageUrl, profileType = _a.profileType, contentSize = _a.contentSize, role = _a.role, linkToProfile = _a.linkToProfile;
    return (_jsxs(Box, { sx: __assign(__assign({}, profileContainerStyle), { gap: contentSize === 'SMALL' ? 2 : 4, backgroundColor: profileType === 'INTERNAL' ? appColors.color.taupe2 : "".concat(appColors.color.blue4, "85") }), children: [profileImageUrl ? (_jsx(Box, { sx: __assign(__assign({}, profileImg), { backgroundImage: "url(".concat(profileImageUrl, ")"), width: contentSize === 'SMALL' ? '70px' : '90px', height: contentSize === 'SMALL' ? '70px' : '90px' }), children: role && _jsx(BackrsUserBadge, { variant: role }) })) : (_jsxs(Box, { children: [_jsx(BackrsIcon, { name: "IconHeadshot", alt: "Profile", height: contentSize === 'SMALL' ? 70 : 90, width: contentSize === 'SMALL' ? 70 : 90, style: genericIconStyle }), role && _jsx(BackrsUserBadge, { variant: role })] })), _jsxs(Box, { children: [_jsxs(Box, { sx: nameAndLinkContainerStyle, children: [_jsx(Box, { sx: abbreviatedNameStyle, children: abbreviatedName }), linkToProfile && (_jsx(Box, { sx: __assign(__assign({}, linkToProfileText), { backgroundColor: profileType === 'INTERNAL' ? appColors.color.taupe1 : appColors.color.blue4 }), onClick: function () { return window.open(linkToProfile, '_blank'); }, children: "Profile" }))] }), _jsxs(Box, { sx: profileInfoContainerStyle, children: [_jsxs(Box, { sx: textGroupContainerStyle, children: [location && (_jsxs(Box, { sx: iconAndTextContainerStyle, children: [_jsx(Box, { children: _jsx(BackrsIcon, { name: "IconMap", alt: "Location" }) }), _jsx(Box, { sx: profileInfoText, children: location })] })), jobTitle && (_jsxs(Box, { sx: iconAndTextContainerStyle, children: [_jsx(Box, { children: _jsx(BackrsIcon, { name: "IconBuilding", alt: "Job Title" }) }), _jsx(Box, { sx: profileInfoText, children: jobTitle })] }))] }), _jsxs(Box, { sx: textGroupContainerStyle, children: [employer && (_jsxs(Box, { sx: iconAndTextContainerStyle, children: [_jsx(Box, { children: _jsx(BackrsIcon, { name: "IconBusiness", alt: "Employer" }) }), _jsx(Box, { sx: profileInfoText, children: employer })] })), school && (_jsxs(Box, { sx: iconAndTextContainerStyle, children: [_jsx(Box, { children: _jsx(BackrsIcon, { name: "IconUniversity", alt: "Job Title" }) }), _jsx(Box, { sx: profileInfoText, children: school })] }))] })] })] })] }));
};
export var NuggetProfile = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'LARGE') {
        return (_jsx(Box, { maxWidth: '70%', children: _jsx(ProfileWidget, __assign({}, variant)) }));
    }
    return _jsx(NuggetProfilePanel, __assign({}, variant));
};
var profileContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '70px 1fr',
    backgroundColor: appColors.color.taupe2,
    borderRadius: 4,
    padding: 2,
    mt: 2,
    overflow: 'hidden',
};
var nameAndLinkContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '8px',
    paddingLeft: function (_a) {
        var backrs = _a.backrs;
        return backrs.spacing['spacing-lg'];
    },
    paddingRight: function (_a) {
        var backrs = _a.backrs;
        return backrs.spacing['spacing-lg'];
    },
};
var linkToProfileText = {
    borderRadius: 2,
    cursor: 'pointer',
    px: 2,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '9pt',
    fontWeight: 600,
    color: appColors.neutral.black,
    lineHeight: 1,
};
var profileImg = {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    aspectRatio: '1 / 1',
    borderRadius: '50%',
};
var abbreviatedNameStyle = {
    fontSize: '12pt',
    lineHeight: 1,
    fontWeight: 700,
    color: appColors.color.navy3,
};
var profileInfoText = {
    fontSize: '10.5pt',
    color: appColors.color.navy3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var iconAndTextContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
};
var textGroupContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    overflow: 'hidden',
};
var profileInfoContainerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 2,
};
var genericIconStyle = {
    overflow: 'hidden',
    borderRadius: '50%',
};
